import React from 'react'
import { Link } from 'react-router-dom'

const TokenMics = () => {
    return (
        <div id='tokenomics' className="token-mics-area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="token-mics-content">
                            <h2 className="text-center top-reveal">
                                Tokenomics
                            </h2>
                            <p className='right-reveal'>We are excited to announce the upcoming beta launch for our groundbreaking poker platform, ZTpoker.com! During the beta stage, we will be running on a testnet to power our games, tournaments and freerolls.
                                We will airdrop tokens to all new users who can then use these tokens to compete, win more, and enjoy exclusive poker experience.
                            </p>
                            <p className='right-reveal'>
                                Please be advised only users who played during beta using the airdrop tokens, will have their tokens transferred to our ZTGM tokens upon full launch in summer 2025.
                            </p>
                            <p className='right-reveal'>
                                Check out the upcoming features and timeline on our roadmap below.
                                <br />
                                Whitepaper available <a href='/whitepaper.pdf' target="_blank" rel="noopener noreferrer">here.</a>
                            </p>
                            <div className="join-table top-reveal">
                                <p>Join now to:</p>
                                <ul>
                                    <li>Be among the first to own and play using our utility tokens.</li>
                                    <li>Support the growth of a community-driven poker platform.</li>
                                    <li>Enjoy secure and transparent blockchain-based gaming.</li>
                                </ul>
                            </div>
                            {/* <div style={{ alignContent: 'center', display: 'flex', justifyContent: 'center', marginTop: '40px' }}>
                                <Link to="/whitepaper.pdf" target='_blank' rel="noopener noreferrer" className='btn btn-border'>Whitepaper</Link>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TokenMics